import { type FC, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

import { showToast } from '@editor2/reducers/toastSlice';
import { ToastSeverity } from '@editor2/types/toastSeverity';
import { disabledInputBlock } from './styles';

interface Props {
	label: string;
	value: string;
}

const CopyInput: FC<Props> = (props) => {
	const { value, label } = props;

	const dispatch = useDispatch();
	const pathRef = useRef(null);

	const showSuccessToast = (message: string) => {
		dispatch(
			showToast({
				severity: ToastSeverity.Success,
				message
			})
		);
	};

	const onCopyClick = (e, ref) => {
		ref.current.select();
		document.execCommand('copy');
		e.target.focus();

		showSuccessToast('Copied');
	};

	return (
		<Form.Group className={disabledInputBlock}>
			<Form.Label>{label}</Form.Label>
			<Form.Control ref={pathRef} type="text" defaultValue={value} readOnly />

			<div onClick={(e) => onCopyClick(e, pathRef)} className="copyButton">
				Copy
				<FaCopy />
			</div>
		</Form.Group>
	);
};

export default CopyInput;
